import { render, staticRenderFns } from "./MobileEdit.vue?vue&type=template&id=5b3c378e&scoped=true&"
import script from "./MobileEdit.vue?vue&type=script&lang=js&"
export * from "./MobileEdit.vue?vue&type=script&lang=js&"
import style0 from "./MobileEdit.vue?vue&type=style&index=0&id=5b3c378e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3c378e",
  null
  
)

export default component.exports